/**
 * /sysadmin/catalog/knowledge — DEPRECATED in PR-J.
 *
 * The "Knowledge packs" sub-tab was a placeholder for a never-built
 * abstraction. Per founder direction 2026-05-08, system knowledge
 * lives under the new `/sysadmin/library` top-level rail using the
 * existing Library tables (folders/articles/tags/documents/sources)
 * scoped via `organization_id IS NULL`.
 *
 * Existing bookmarks (and any deep-links from the catalog tab strip
 * before PR-J merged) redirect to /sysadmin/library so users land on
 * the new home.
 */

import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/sysadmin/catalog/knowledge')({
  beforeLoad: () => {
    throw redirect({ to: '/sysadmin/library', replace: true });
  },
});
